

import { gql } from "@apollo/client";
import { post, fetchLang } from '@util/http';
import { toURLSearchParams } from '@util/utils'
import { getUrl } from "../util/utils";
import { ym_url } from "@util/enum";
import {
  MOCK_PRODUCT_LAUNCH,
  mockQueryPrivateSaleProduct,
  mockQueryPrivateSaleCategoryTree,
  mockReportProductView,
} from "@api/mock";


export const CREATE_PRODUCT = gql`
	mutation _CREATE_PRODUCT($product:CreateProductInput){
	 create_product(product:$product){
		  id
		  name
	  }
  }
`


export const QUERY_PRODUCT = gql`
	query _QUERY_PRODUCT($id:String!){
	 query_product_by_id(id:$id){
        id
				name
				covers
        coversV2
				topTypeId
				secondTypeId
        type
				model
				place_origin
				special
				certification
        certificationV2
				cases
				brand_id
				usageScenariosUrl
        usageScenariosUrlsV2
        productNotes
				colors
				package_info
				dynamicParam
				nodes
				supply_cycle
        supplyCycleType
        supply_cycle_max
        supplyCycleUnit
				sizes
				place_origin
				parts
				tags
        priceType
				reference_price
				experience
				attachment
				status
        privateHighestType{
          id
          name
        }
				secondType{
					id
					name
				}
				topType{
					id
					name
				}
        clientId
        checkInfo
         brand {
          id
          name
          logo
          sourceType
        }
        client
        clientType
				uid
        style
        byMaterialId
        service
        byMaterial
        bestChecked 
        disabled
        disInfo
        contactInfo
        privateTopTypeId
        privateSecondTypeId
        privateType
        privateSecondType{
					id
					name
				}
				privateTopType{
					id
					name
				}
        privateBrandName
        highestType{
          id
          name
          clientId
          clientType
        }
        sourceType
        priceUnit
        usageScenariosUrls
        supplier
        frame
        updateFlag
        discard
        comeFrom
        size
        onSale
        specificationAndDimension
        productIntroduction
        texture
        pSourceId
        dynamicFields
        customFields
        designStyles
        tempData
        tmCreate
	  }
  }
`

export const UPDATE_PRODUCT = gql`
  mutation UPDATE_PRODUCT($product:UpdateProductInput){
     update_product(product:$product){
      id
      name
     }
  }
  `
export const UPDATE_PRODUCT_STATUS = gql`
  mutation UPDATE_PRODUCT_STATUS($id:String!,$status:Int!){
    update_product_status(id:$id,status:$status){
      success
      result
      error
      info
     }
  }
  `


export const DELETE_PRODUCT = gql`
  mutation DELETE_PRODUCT($id:String!){
     delete_product(id:$id){
      id
      name
     }
  }
  `

/**
 * 多条件查询严选材料
 */
export const QUERY_PRODUCT_BY_CON = gql`
	query _QUERY_PRODUCT_BY_CON($con: QueryBestInput){
    query_product_by_con(con:$con){
      total
      hasNext
      products{
          id
          name
          covers
          topTypeId
          secondTypeId
          model
          place_origin
          special
          certification
          cases
          brand_id
          brand {
            id
            name
          }
          best 
          usageScenariosUrl
          colors
          package_info
          dynamicParam
          nodes
          supply_cycle
          sizes
          place_origin
          parts
          tags
          reference_price
          experience
          attachment
          status
          secondType{
            id
            name
          }
          topType{
            id
            name
          }
          uid
          onSale
          clientId
          checkInfo
          style
          byMaterialId
          clientType
          client
          tmCreate
          bestChecked
          disabled
          disInfo
          byMaterial
          contactInfo
          stared
          type
          privateSecondTypeId
          privateSecondType{
            id
            name
          }
          privateTopTypeId
          privateTopType{
            id
            name
          }
          privateType
          privateHighestType{
            id
            name
          }
          supplier
          service
          tags
          customFieldList
          productSkus
          productAttachmentVOS
      }
    }
  }
  `
/**
 * 多条件查询严选材料
 */
export function QUERY_PRODUCT_BY_CON_POST(params) {
  return post('/api/product/queryProductByCon', params)
}

export function productInfoFilterColorSkuAttachmentImages(params) {
  return post('/api/product/productInfoFilterColorSkuproductAttachmentsImages', params)
}

export function queryProductSpecifications(productId) {
  return fetchLang('/api/product/specifications?' + new URLSearchParams({ productId }).toString(), {
    method: 'GET',
  }).then(res => res.json())
}
/**
 * 多条件查询严选材料222
 */
export function QUERY_PRODUCT_BY_CON_POST_TWO(obj) {
  let url = getUrl();
  // 写的什么sb代码
  if(url == 'http://dev.panzitech.com:3001/'){
    url = `https://${ym_url.test}/`
  }
  return post(url + 'graphql', {
    "operationName": "_ES_QUERY_TEAM_PRODUCT_BY_CON",
    "variables": {
      "con": obj
    },
    "query": "query _ES_QUERY_TEAM_PRODUCT_BY_CON($con: Object) {\n  es_query_team_product_by_con(condition: $con)\n}"
  })
}

/**
 * 多条件查询严选材料
 */
export const QUERY_DESIGNER_PRODUCT_BY_CON = gql`
	query _QUERY_DESIGNER_PRODUCT_BY_CON($con: QueryBestInput){
    query_designer_product_by_con(con:$con){
      total
      hasNext
      products{
          id
          name
          covers
          topTypeId
          secondTypeId
          model
          place_origin
          special
          certification
          cases
          brand_id
          brand{
            id
            name
          }
          best 
          usageScenariosUrl
          productNotes
          colors
          package_info
          dynamicParam
          nodes
          supply_cycle
          supplyCycleUnit
          sizes
          place_origin
          parts
          tags
          reference_price
          experience
          attachment
          status
          secondType{
            id
            name
          }
          topType{
            id
            name
          }
          uid
          onSale
          clientId
          client
          checkInfo
          style
          byMaterialId
          tmCreate
          bestChecked
          clientType
          disabled
          discard
          disInfo
          contactInfo
          type
          privateBrandName
      }
    }
  }
  `

// 单个批量上架下架
export const BATCH_UPDATE_PRODUCT = gql`
  mutation _BATCH_UPDATE_PRODUCT($params:OnSaleDto!){
    update_product_on_sale(params:$params){
      id
    }
  }
`


/**
* 多条件查询严选材料
*/
export const COUNT_DESIGNER_PRODUCT_BY_CON = gql`
	query _COUNT_DESIGNER_PRODUCT_BY_CON($con: QueryBestInput){
    count_designer_product_by_con(con:$con)
  }
  `


/**
* 按条件统计成品
*/
export const COUNT_PRODUCT_BY_CON = gql`
	query _COUNT_PRODUCT_BY_CON($con: QueryBestInput){
    count_product_by_con(con:$con)
  }
  `

// 添加推荐产品
export const ADD_RECOMMEND_PRODUCT = gql`
  mutation _ADD_RECOMMEND_PRODUCT($params:Object!){
    addRecommendProduct(recommend:$params) {
      success
      info
      error
      result
    }
  }
`

// 移除推荐产品
export const REMOVE_RECOMMEND_PRODUCT = gql`
  mutation _REMOVE_RECOMMEND_PRODUCT($params:Object!){
    removeRecommendProduct(recommend:$params) {
      success
      info
      error
      result
    }
  }
`

/**
* 查询推荐产品
*/
export const QUERY_RECOMMEND_PRODUCT = gql`
	query _QUERY_RECOMMEND_PRODUCT($clientId: String){
    queryRecommendProduct(clientId:$clientId)
  }
  `
// 复制产品
export const COPY_PRODUCT = gql`
  mutation _COPY_PRODUCT($id:String){
    copyProduct(id:$id){
      result
      success
    }
  }
  `

/**
* 发起PDF转图片请求
*/
export const pdf2ImageAsync = (params) => post('/api/pdf2ImageAsync', params);

/**
* 查询PDF转换出的所有图片集合
*/
export const queryPdf2ImageAsyncResult = (params) => post('/api/queryPdf2ImageAsyncResult', params);

/**
*  查询PDF页码数
*/
export const queryNumberOfPdfPages = (params) => post('/api/queryNumberOfPdfPages', params);



export const UPDATE_PRODUCT_BEST = gql`
  mutation UPDATE_PRODUCT_BEST($params:UpdateProductBestInput){
    update_product_best(params:$params){
      id
    }
  }
  `

// 批量删除产品
export const BATCH_REMOVE_SELF_PRODUCT = gql`
  mutation _BATCH_REMOVE_SELF_PRODUCT($clientId:String!,$productIds:[String!],$type:String ){
    batchRemoveSelfProduct(clientId:$clientId,productIds:$productIds,type:$type){
      result
      success
    }
  }
  `
// 官方产品列表查询修改
export const ES_QUERY_PRODUCT_BY_CON = gql`
	query _ES_QUERY_PRODUCT_BY_CON($con: Object){
    es_query_product_by_con(condition:$con)
  }
  `

export const ES_QUERY_DESIGNER_PRODUCT_BY_CON = gql`
	query _ES_QUERY_DESIGNER_PRODUCT_BY_CON($con: Object){
    es_query_designer_product_by_con(condition:$con)
  }
  `

export const ES_QUERY_RECRUITMENT_BY_CON = gql`
  query _ES_QUERY_RECRUITMENT_BY_CON($con: Object){
    es_query_recruitment_by_con(condition: $con)
  }
`
const headers = {
  "content-type": "application/json"
}


//查询官方库接口
export function esQueryProductByCon(params) {
  return fetchLang('/api/es/es_query_product_by_con', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

export function shareLinkVisitCount(params) {
  return fetchLang('/api/spectaculars/shareLinkVisitCount', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 浏览量上报（产品：《产品推荐上市 — 接口文档》五）。
// businessType 1 = 产品；platform 1 PC浏览 / 2 PC分享 / 3 H5浏览 / 4 H5分享 / 5 小程序 / 6 APP / 7 紫菜海洋
export function reportProductView(params) {
  // mock 开关与 mock 实现见 @api/mock，置为 false 即走下方真实请求
  if (MOCK_PRODUCT_LAUNCH) return mockReportProductView(params);
  return fetchLang('/api_point/view/report', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 查询资材发布是否需要覆盖 
export function needReplace(params) {
  return fetchLang('/api/product/needReplace', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 询价

// 发起询价
export function createWorkOrder(params) {
  return fetchLang('/api/enquiry/createWorkOrder', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 发起询价(无需登录也可发起询价)
export function createTempWorkOrder(params) {
  return fetch('/api/enquiry/createTempWorkOrder', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 红点提示
export function pendingWorkOrderCount(params) {
  return fetchLang('/api/enquiry/pendingWorkOrderCount', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 询价收件箱|询价发件箱
export function workOrderBox(params) {
  return fetchLang('/api/enquiry/workOrderBox', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 询价单详情
export function workOrderDetail(params) {
  return fetchLang('/api/enquiry/workOrderDetail', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 忽略询价单
export function workOrderIgnore(params) {
  return fetchLang('/api/enquiry/workOrderIgnore', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 询价单报价
export function workOrderQuote(params) {
  return fetchLang('/api/enquiry/workOrderQuote', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 询价单转单
export function workOrderTransfer(params) {
  return fetchLang('/api/enquiry/workOrderTransfer', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 获取询价发起人信息
export function getUserInfo(params) {
  return fetchLang('/api/enquiry/getUserInfo', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
// 导出询价报价单
export function exportWorkOrderDetail(params) {
  return fetchLang(toURLSearchParams('/api/enquiry/exportWorkOrderDetail', params), {
    method: "GET",
    headers,
  }).then(res => res.json())
}
// 获取询价导出模版列表 
export function findTeamDrawBoardListPage(params) {
  return fetchLang(toURLSearchParams(`/api/teamDrawBoard/findTeamDrawBoardListPage`, params), {
    method: "GET",
    headers,
  }).then(res => res.json())
}

// 查询资材标签
export function getProductTag(params) {
  return fetchLang('/api/tag/queryTagByTeam', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 删除团队产品标签
export function delProductTag(params) {
  return fetchLang('/api/tag/delTag', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 保存团队产品标签
export function saveProductTag(params) {
  return fetchLang('/api/tag/save', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

//  新增资材--新接口
export function createProductApi(params) {
  return fetchLang('/api/product/createProduct', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

//  修改资材--新接口
export function updateProductApi(params) {
  return fetchLang('/api/product/updateProduct', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 入库资材 /api/product/productWarehousing
export function productWarehousing(params) {
  return fetchLang('/api/product/productWarehousing', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 公域产品入库 /api/product/publicSaleWarehousing
export function publicSaleWarehousing(params) {
  return fetchLang('/api/product/publicSaleWarehousing', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 委托入库 /api/entrust/warehousing
export function entrustproductWarehousing(params) {
  return fetchLang('/api/entrust/warehousing', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 资材图片压缩-生成四张压缩图
export function uploadImgNewInQueue(params) {
  return post('/api/uploadImgNewInQueue', params)
}

// 素材库名字搜索
export function queryThroughImagesLib(params) {
  return fetchLang('/api/cloud/queryThroughImagesLib', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 管理员 批量审核上下架
export function batchUpdateOnSale(params) {
  return fetchLang('/api/admin/batchUpdateOnSale', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

export function queryPrivateSaleProductList(params) {
  return fetchLang('/api/admin/queryPrivateSaleProductList', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 产品推荐管理弹窗（推荐设置 / 新品设置）左侧「可选产品」：查询团队私域已上架产品（分页）
export function queryPrivateSaleProduct(params) {
  // mock 开关与 mock 实现见 @api/mock，置为 false 即走下方真实请求
  if (MOCK_PRODUCT_LAUNCH) return mockQueryPrivateSaleProduct(params);
  return fetchLang('/api/product/queryPrivateSaleProduct', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 产品推荐管理弹窗（推荐设置 / 新品设置）左侧分类下拉：查询团队分类树（含私域上架数量）
export function queryPrivateSaleCategoryTree(params) {
  // mock 开关与 mock 实现见 @api/mock，置为 false 即走下方真实请求
  if (MOCK_PRODUCT_LAUNCH) return mockQueryPrivateSaleCategoryTree(params);
  return fetchLang('/api/product/queryPrivateSaleCategoryTree', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

export function auditPrivateSale(params) {
  return fetchLang('/api/admin/auditPrivateSale', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

export function batchAuditPrivateSale(params) {
  return fetchLang('/api/admin/batchAuditPrivateSale', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

export function countPendingPrivateSaleTeamNum() {
  return fetchLang('/api/admin/countPendingPrivateSaleTeamNum', {
    method: "POST",
    headers,
  }).then(res => res.json())
}
// 查询资材详情
export function queryProductById(id) {
  return fetchLang('/api/product/queryProductById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}
// 查询资材详情返回多语言的
export function queryProductMlById(id) {
  return fetchLang('/api/product/queryProductMlById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}
// 查询资材详情包括了分类和品牌详情
export function queryProductViewById(id) {
  return fetchLang('/api/product/queryProductViewById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}

// 查询资材详情（新接口，入参返参与 queryProductViewById 一致）
export function oceanProductViewDetail(id) {
  return fetchLang('/api/ocean/product/view/detail?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}

// 浏览模式下查询资材详情包括了分类和品牌详情（单独）
export function callerQueryProductViewById(id) {
  return fetchLang('/api/product/callerQueryProductViewById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}

// 官方模式下查询资材详情包括了分类和品牌详情（国际产品详情页专用，替换 callerQueryProductViewById）
export function officialQueryProductViewById(id) {
  return fetchLang('/api/product/officialQueryProductViewById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}

// 查询资材详情返回多语言的包括了分类和品牌详情
export function queryProductViewMlById(id) {
  return fetchLang('/api/product/queryProductViewMlById?id='+id, {
    method: "GET",
    headers
  }).then(res => res.json())
}

// 查询团队及官方产品标签(多语言)
export function queryTagsMlByTeam(params) {
  return fetchLang('/api/tag/queryTagsMlByTeam', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 删除团队分类
export function removeMaterialLevel(params) {
  return fetchLang('/api/material/removeMaterialLevel', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}
//  定制小程序的方法 查询 分享二维码的状态
export function getAppletQrCodeShortLink(params) {
  return fetchLang('/api/customized/getAppletQrCodeShortLink', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

//查询资材，价格根据权限来
export function findShareProductInfo(params) {
  return fetchLang('/api/product/findShareProductInfo?' + new URLSearchParams(params).toString(), {
    method: "GET",
  }).then(res => res.json())
}

//  查询资材 已入库 或 未入库
export function findProductsByStockStatus(params) {
  return fetchLang('/api/teamMix/findProductsByStockStatus', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

//  修改资材状态为出库
export function updateProductOutWarehouse(params) {
  return fetchLang('/api/teamMix/updateProductOutWarehouse', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

//  获取阿里云oss临时授权token
export function getAssumeRoleByUser(params) {
  return fetchLang('/api/auth/getAssumeRoleByUser', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 根据文件签名码查询云盘文件信息（秒传校验/文件去重）
export function queryCloudFileBySignatureCode(params) {
  return fetchLang(toURLSearchParams('/api/cloudFile/fileSignatureCode', params), {
    method: "GET",
    headers,
  }).then(res => res.json())
}

// 获取图片上传文件夹id
export function imagesFolders(params) {
  return fetchLang(toURLSearchParams('/api/cloudFolder/imagesFolders', params), {
    method: "GET",
    headers,
  }).then(res => res.json())
}

// 查询规格字段列表（含推荐排序）
export function querySpecFieldsWithRecommend(params) {
  return post('/api/secondTypeSpecMapping/querySpecFieldsWithRecommend', params)
}
